import {graduatesBackendGet} from "@/services/api";


const state = {
  graduates: [],
  didLoadGraduates: false,
};

const getters = {
  getGraduates: (state) => state.graduates,
  didLoadGraduates: (state) => state.didLoadGraduates,
};

const actions = {

  async fetchAllGraduates({ commit }) {
    commit("startedDataDownload");
    await graduatesBackendGet("graduate/")
      .then((response) => {
        commit("setGraduates", response.data.items);
        commit("finishedDataDownload");
      });
  },

  async exportGraduates({ commit }) {
    commit("startedDataDownload");
    try {
      const response = await graduatesBackendGet('graduate/export', null, true)

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'graduates.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

    } catch (err) {
        console.error('Failed to download XLSX:', err)
        throw err;
    }
  }
};

const mutations = {
  startedDataDownload: (state) => (state.didLoadGraduates = false),
  finishedDataDownload: (state) => (state.didLoadGraduates = true),
  setGraduates: (state, graduates) => (state.graduates = graduates)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
